import React from "react";
import FooterNext from "../Footers/FooterNext";
import { Container, Row, Col, Card } from "react-bootstrap";

function ProfessionalResumeWritersTermsandConditions() {
  return (
    <div style={{ overflowX: "hidden" }}>
      <Container fluid className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Row className="justify-content-center mx-0">
          <Col md={8} sm={12} className="px-3">
            <Card className="shadow-lg border-0 rounded-4">
              <Card.Body className="p-4 text-start"> {/* force left alignment */}
                <h2 className="mb-4">Terms & Conditions</h2>

                <h5 className="mt-3">1. Eligibility</h5>
                <p>
                  The Professional Resume Writer’s Services are available{" "}
                  <strong>exclusively for Dr Planete’s Doctor Members</strong>{" "}
                  who have purchased either the{" "}
                  <strong>Basic Lifetime Doctor Membership</strong> (entitled to
                  one-time access) or the{" "}
                  <strong>Pro Doctor Membership</strong> (entitled to unlimited
                  access). This service is not available for hospital members,
                  student members, or non-members.
                </p>

                <h5 className="mt-3">2. Service Entitlement & Turnaround Time</h5>
                <p>
                  <strong>Basic Lifetime Doctor Members:</strong> Eligible for
                  one-time use of the service, with a delivery time of{" "}
                  <strong>3–5 business days</strong> from the date of submission
                  of all required information and documents.
                </p>
                <p>
                  <strong>Pro Doctor Members:</strong> Eligible for unlimited
                  uses of the service, with a priority turnaround time of{" "}
                  <strong>48 hours</strong> from the date of submission of all
                  required information and documents.
                </p>

                <h5 className="mt-3">3. Responsibility & Liability</h5>
                <p>
                  The resume will be created solely on the basis of the
                  information and certificates provided by the member.{" "}
                  <strong>Dr Planete does not verify or authenticate any
                  certificate, qualification, or credential</strong> submitted by
                  the member. Members are fully responsible for the accuracy,
                  completeness, and truthfulness of the information they provide.
                </p>
                <p>
                  Dr Planete and its employees shall not be held liable for any
                  direct, indirect, incidental, or consequential outcomes
                  resulting from the use of this service.
                </p>

                <h5 className="mt-3">4. Access & Communication</h5>
                <p>
                  This service can only be accessed through{" "}
                  <strong>Dr Planete’s Mobile App</strong>. Further
                  communication, updates, and coordination will be handled
                  exclusively through Dr Planete’s official WhatsApp number:{" "}
                  <strong>+91 8619460759</strong>.
                </p>

                <h5 className="mt-3">5. Conduct</h5>
                <p>
                  In case of any inappropriate behavior, misuse of services, or
                  violation of terms by the customer, Dr Planete reserves the
                  full right to refuse or terminate the service without any
                  obligation of refund.
                </p>

                <h5 className="mt-3">6. General Disclaimer</h5>
                <p>
                  The Professional Resume Writer’s Service is provided strictly
                  on an “as-is” basis. Dr Planete does not guarantee any job
                  placement, interview calls, or career advancement outcomes
                  resulting from the use of this service.  
                </p>
                <p>
                  Members are solely responsible for the consequences of sharing
                  or using their resumes. By availing this service, members
                  acknowledge that they understand and agree to all the above
                  terms without limitation.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ProfessionalResumeWritersTermsandConditions;
